import React from 'react'
import TableFixedPage from '../../TableFixedPage/TableFixedPage'
import Style from './CreatePublicDiscountCodeContainer.module.scss'
import CreatePublicDiscountCode from '../../Forms/CreatePublicDiscountCode/CreatePublicDiscountCode'
const CreatePublicDiscountCodeContainer = () => {
  return (
    <section className={Style.PageHolder}>
        <TableFixedPage title={"ایجاد کد تخفیف عمومی"} />
        <CreatePublicDiscountCode/>
    </section>
  )
}

export default CreatePublicDiscountCodeContainer